import { render, staticRenderFns } from "./RoomMembersChip.vue?vue&type=template&id=a9a08130&lang=pug&"
import script from "./RoomMembersChip.vue?vue&type=script&lang=ts&"
export * from "./RoomMembersChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RoomMembersChip.vue"
export default component.exports